<template>
  <div :class="ufClass" v-if="isAvailableShow">
    <InputSelect
      :label="`${ufLabel}:`"
      name="uf"
      v-model="uf"
      @change="onChangeCarregarMunicipios"
      placeholder="Selecione uma das opções"
      :required="required"
      :options="stateList"
      :disabled="disableMod"
    />
  </div>
  <div
    :class="municipioClass"
    v-if="isAvailableShow && isAvailableShowMunicipio"
  >
    <InputSelect2
      v-if="municipioName"
      :label="`${municipioLabel}:`"
      name="municipio_id"
      v-model="municipio"
      :disabled="(isFilter && !municipios.length) || disableMod"
      @change="onChange()"
      placeholder="Selecione uma das opções"
      :required="requiredMunicipio !== undefined ? requiredMunicipio : required"
      :options="municipios"
    />
    <InputSelect
      v-else
      :label="`${municipioLabel}:`"
      name="municipio_id"
      v-model="municipio"
      :disabled="(isFilter && !municipios.length) || disableMod"
      @change="onChange()"
      placeholder="Selecione uma das opções"
      :required="requiredMunicipio !== undefined ? requiredMunicipio : required"
      :options="municipios"
    />
  </div>
</template>

<script lang="ts" setup>
import {
  defineComponent,
  defineProps,
  defineEmits,
  reactive,
  toRefs,
  computed,
  watch,
  ref,
  onMounted,
} from "vue";
import { stateList as states } from "@/core/listas/stateList";
import { useUsuarioStore } from "@/store/usuarioStore";
import axios from "axios";
const usuarioStore = useUsuarioStore();

const emit = defineEmits(["changeUf", "update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  municipioLabel: {
    type: String,
    default: "Município",
  },
  municipioName: {
    type: Boolean,
    default: false,
  },
  ufLabel: {
    type: String,
    default: "UF",
  },
  isAvailableShow: {
    type: Boolean,
    default: true,
  },
  isAvailableShowMunicipio: {
    type: Boolean,
    default: true,
  },
  municipioClass: {
    type: String,
    default: "col-sm-4",
  },
  ufClass: {
    type: String,
    default: "col-sm-2",
  },
  currentUf: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredMunicipio: {
    type: Boolean,
    default: undefined,
  },
  isFilter: {
    type: Boolean,
    default: false,
  },
  disableMod: {
    type: Boolean,
    default: false,
  },
});

const data = reactive({
  municipios: [] as any,
  uf: "" as any,
  municipio: "" as any,
});

const { municipios, uf, municipio } = toRefs(data);

const municipioSelected = ref({ municipioId: "", municipioNome: "" });

const stateList = computed(() => {
  const ufsPermitidas = usuarioStore.perfilDados?.uf;
  if (ufsPermitidas && ufsPermitidas.length > 0) {
    return states.filter((state) => ufsPermitidas.includes(state.value));
  }
  return states;
});

async function onChangeCarregarMunicipios(event) {
  const uf = event?.target?.value || event;
  data.uf = uf;
  emit("changeUf", data.uf);
  if (uf && uf !== "clearfilter") {
    try {
      const response = await axios.get(
        process.env.VUE_APP_ADMIN_API + "/municipio/listagem/" + uf
      );

      let municipiosList = response.data.dados
        .map((dado) => ({
          value: props.municipioName ? String(dado.id) : dado.id,
          label: dado.nome,
        }))
        .filter((municipio) => String(municipio.label ?? "").trim() !== "");

      const perfilMunicipioId = usuarioStore.perfilDados?.municipioId;
      if (perfilMunicipioId) {
        const municipioValue = props.municipioName
          ? String(perfilMunicipioId)
          : perfilMunicipioId;
        municipiosList = municipiosList.filter(
          (municipio) => municipio.value === municipioValue
        );
        if (municipiosList.length === 1) {
          if (props.municipioName) {
            data.municipio = {
              value: municipioValue,
              text: municipiosList[0].label,
            };
          } else {
            data.municipio = municipioValue;
          }
          emit("update:modelValue", data.municipio);
        }
      }

      data.municipios = municipiosList;
    } catch (error) {
      data.municipios = [];
    }
  } else {
    data.municipios = [];
  }
}

function onChange() {
  const selectedValue = props.municipioName
    ? data.municipio?.value
    : data.municipio;
  const municipioNome = (
    data.municipios.find((option) => option.value == selectedValue) || {}
  ).label;
  emit("getMunicipioNome", municipioNome);
  if (props.municipioName && data.municipio?.value) {
    data.municipio = {
      value: data.municipio.value,
      text: municipioNome,
    };
  }
  return emit("update:modelValue", data.municipio);
}

onMounted(async () => {
  if (props.currentUf) {
    data.uf = props.currentUf;
    onChangeCarregarMunicipios(props.currentUf);
  }

  if (props.modelValue) {
    if (props.municipioName && typeof props.modelValue !== "object") {
      data.municipio = {
        value: String(props.modelValue),
        text: "",
      };
    } else {
      data.municipio = props.modelValue;
    }
  }
});

watch(
  () => props.currentUf,
  (value) => {
    if (value === "clearfilter") {
      data.uf = null;
      data.municipios = [];
      return;
    }
    if (value) {
      data.uf = value;
      onChangeCarregarMunicipios(value);
    }
  }
);

watch(
  () => props.modelValue,
  (modelValue) => {
    if (props.municipioName && typeof modelValue !== "object") {
      data.municipio = {
        value: String(modelValue),
        text: "",
      };
      return;
    }
    data.municipio = modelValue;
  }
);

watch(
  () => props.isAvailableShow,
  (value) => {
    if (!value) {
      data.municipio = "";
      data.uf = "";
    }
  }
);

watch(
  () => stateList.value,
  (lista) => {
    if (lista.length === 1 && !data.uf) {
      data.uf = lista[0].value;
      onChangeCarregarMunicipios(data.uf);
    }
  },
  { immediate: true }
);
</script>
